import {Component, inject, Input, OnChanges, SimpleChanges,} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';

@Component({
  selector: 'app-svg-icon',
  standalone: true,
  template: `
    <div class="svg-container" [innerHTML]="sanitizedSvgContent"></div>`,
  styleUrl: './svg-icon.component.scss',
})
export class SvgIconComponent implements OnChanges {
  @Input({required: true}) src!: string;
  @Input() color?: string;
  @Input() size?: string;

  sanitizedSvgContent: SafeHtml | null = null;

  private http = inject(HttpClient);
  private sanitizer = inject(DomSanitizer);

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['src'] && this.src) {
      this.loadSvg();
    }
  }

  private loadSvg(): void {
    this.http.get(this.src, {responseType: 'text'}).subscribe((svg) => {
      const svgWithColorAndSize = this.applyStyles(svg);
      this.sanitizedSvgContent = this.sanitizer.bypassSecurityTrustHtml(
        svgWithColorAndSize
      );
    });
  }

  private applyStyles(svg: string): string {
    const parser = new DOMParser();
    const doc = parser.parseFromString(svg, 'image/svg+xml');
    const svgElement = doc.documentElement;

    if (this.color) {
      svgElement.setAttribute('fill', this.color);
    }
    if (this.size) {
      svgElement.setAttribute('width', this.size);
      svgElement.setAttribute('height', this.size);
    }

    return new XMLSerializer().serializeToString(svgElement);
  }
}
